<template>
  <div v-if="loading" class="flex justify-center">
    <q-spinner-dots color="primary" size="40px" />
  </div>
  <div v-else-if="hasMore" class="flex justify-center">
    <PBtn flat text @click="$emit('load-more')">Show More</PBtn>
  </div>
</template>

<script setup>
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  hasMore: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["load-more"]);
</script>
